import React, { useRef, useEffect } from "react";
import { Transition } from 'react-transition-group';

export const MegaMenu = ({ item, index, open, handleDropdownClick, setActiveDropdown }) => {
  const transitionRef = useRef(null);
  const content = useRef(null);

  const defaultStyle = {
    transition: `opacity 300ms ease-in-out`,
    opacity: 0
  }

  const transitionStyles = {
    entering: { opacity: 1, visibility: 'visible' },
    entered:  { opacity: 1, visibility: 'visible' },
    exiting:  { opacity: 0, visibility: 'visible' },
    exited:  { opacity: 0, visibility: 'hidden' },
  };

  useEffect(() => {
    if (content) {
      content.current.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          const elements = content.current.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe");
          const first = elements[0];
          const last = elements[elements.length - 1];

          if (e.target === last && !e.shiftKey) setActiveDropdown(null);
          if (e.target === first && e.shiftKey) setActiveDropdown(null);
        }
      })
    }
  }, [content]);

  return (
    <div 
      data-dropdown-parent
      ref={content}
    >
      <button 
        className="flex items-center gap-[0.375rem] py-4 uppercase font-medium"
        aria-expanded={open}
        aria-controls={`DropdownContent-${index}`}
        onClick={() => handleDropdownClick(index)}
        data-dropdown-trigger={`DropdownTrigger-${index}`}
      >
        <span className="pointer-events-none underline underline-offset-4 decoration-transparent hover:decoration-black transition uppercase">{item.title}</span>
        <svg aria-hidden="true" aria-focusable="false" width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg" className={`transition pointer-events-none ${open && `rotate-180`}`}>
          <path d="M4 4L0 0H8L4 4Z" fill="currentColor"/>
        </svg>
      </button>
      <Transition transitionRef={transitionRef} in={open} timeout={500}>
        {state => (
          <div 
            ref={transitionRef} 
            style={{
              ...defaultStyle,
              ...transitionStyles[state]
            }}
            className={`transition absolute z-10 bg-blush-100 w-full left-0`}
            id={`DropdownContent-${index}`}
            tabIndex={-1}
          >
            <div className="max-w-[79rem] mx-auto p-[1rem] pt-[2.5rem] pb-[3.5rem] grid grid-cols-5 gap-[3rem]">
              {item.links.map((childlink, index) => {
                if (!('links' in childlink) || index > 2) return null;

                return (
                  <div>
                    <span className="uppercase text-gray-800 inline-block mb-3 font-heading text-[1.75rem]">{childlink.title}</span>
                    <ul className="list-none" role="list">
                      {childlink.links.map((grandChildLink) => {
                        const result = grandChildLink.title.match(/({{\s[^{]*?)\w\s(?=\})}}/g);
                        let title, tag;
                        if (result && result.length > 0) {
                          tag = result[0].replace(/[{}|\s]/g, '');
                          title = grandChildLink.title.split(' {{')[0];
                        } else {
                          tag = null;
                          title = grandChildLink.title;
                        }

                        if (!title) return null;
                        return <li className="list-none">
                          <a 
                            href={grandChildLink.url} 
                            className="inline-block py-[0.5rem] text-[0.875rem] leading-6"
                            aria-current={grandChildLink.current}
                          >
                            <span className="mr-[0.375rem] transition underline underline-offset-4 decoration-transparent hover:decoration-black uppercase">{title}</span>
                            {tag && <span className="font-medium text-[0.5rem] text-white bg-black rounded-[0.25rem] uppercase pt-[0.275rem] pb-[0.2rem] px-[0.25rem] tracking-wide relative bottom-[0.125rem]">{tag}</span>}
                          </a>
                        </li>
                      })}
                    </ul>
                  </div>
                )
              })}

              {item.content?.feature_image && item.content?.feature_url &&
                <div className="col-start-4 col-span-2">
                <div className="relative">
                  <a 
                    href={item.content.feature_url} 
                    className="absolute top-0 left-0 w-full h-full"
                  >
                    <span className="sr-only">{item.content.feature_text_stripped ? item.content.feature_text_stripped : item.content.feature_image.alt }</span>
                  </a>
                  <img src={item.content.feature_image.url} alt={item.content.feature_image.alt} className="'w-full" />
                  {item.content.feature_text &&
                    <div aria-hidden="true" className="bg-black text-white p-[0.75rem] text-center text-[0.8125rem] font-medium uppercase" dangerouslySetInnerHTML={{ __html: item.content.feature_text }}></div>
                  }
                </div>
              </div>
              }
            </div>

            {item.content?.footer_text &&
                <div className="bg-blush-400">
                  <div className="flex justify-between items-center max-w-[79rem] mx-auto p-[1rem]">
                    <div className="flex items-center gap-[0.75rem]">
                      {item.content?.footer_icon &&
                        <img src={item.content.footer_icon.url} alt="" width="24" />
                      }

                      {item.content.footer_url 
                        ?
                        <a href={item.content.footer_url} className="underline underline-offset-4">
                          <span>{item.content.footer_text}</span>
                        </a>
                        :
                        <span>{item.content.footer_text}</span>
                      }
                    </div>
                    {item.content.footer_additional_text &&
                      <div className="text-xs leading-4" dangerouslySetInnerHTML={{ __html: item.content.footer_additional_text }}></div>
                    }
                  </div>
                </div>
              }
          </div>
        )}
      </Transition>
    </div>
  )
}